import { findObjectUseCase } from "../../usecases/object";
import { getAllSchemasUseCase } from "../../usecases/schema/usecases";

class SignUpPresenter {
  constructor(view, signUpUseCase, updateObjectUseCase, getSchemaUseCase) {
    this.view = view;
    this.signUpUseCase = signUpUseCase;
    this.updateObjectUseCase = updateObjectUseCase;
    this.getSchemaUseCase = getSchemaUseCase;
    this.change = {};
  }

  componentDidMount() {
    this.init();
  }

  async init() {
    this.view.showProgress();
    try {
      await this.getSchema();
      this.view.hideProgress();
    } catch (error) {
      this.view.hideProgress();
      switch (error.code) {
        case 401:
          this.view.navigateTo("/signin");
          break;
        case 403:
          this.view.navigateTo("/app");
          break;
        default:
          this.view.showError(error);
      }
    }
  }

  async getObject() {
    try {
      const schemas = await findObjectUseCase("users");
      this.view.setSchemas(schemas);
    } catch (error) {
      throw error;
    }
  }

  // async getSchema() {
  //   try {
  //     const schema = await this.getSchemaUseCase.execute("users");
  //     this.view.setSchemas([schema]);
  //   } catch (error) {
  //     throw error;
  //   }
  // }
  async getSchema() {
    try {
      const schemas = await getAllSchemasUseCase().execute();
      console.log(schemas);
      this.view.setSchemas(schemas);
    } catch (error) {
      throw error;
    }
  }

  async submit() {
    const { password, confirmPassword, ...others } = this.change;

    if (password !== confirmPassword) {
      this.view.showError("password must be the same");
      return;
    }

    const user = {
      password,
      acl: {},
      ...others,
    };

    user.affiliate = { id: user.affiliate.id };
    user.branch = { id: user.branch.id };
    user.registrationStatus = "Pending";

    this.view.showProgress();

    try {
      const [existing] = await findObjectUseCase().execute(
        "users",
        {
          where: { username: others.username },
          limit: 1,
        },
        { session: "7c2e91b4-3f5d-4a87-b16e-d94a0c5f2e13" },
      );

      if (existing) {
        this.view.hideProgress();
        this.view.showError(`Username "${others.username}" is already taken.`);
        return;
      }

      await this.signUpUseCase.execute(user);
      this.view.hideProgress();
      this.view
        .showSuccess("Your account has been successfully created.")
        .then(() => {
          this.view.navigateTo("/signin");
        });
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }

  onChange(value, field) {
    this.change[field] = value;
    this.view.setObject(this.change);
  }
}

export default SignUpPresenter;
